import _ from 'lodash';
import FormControl from '@mui/material/FormControl';
import FormHelperText from '@mui/material/FormHelperText';
import FormLabel from '@mui/material/FormLabel';
import RadioGroup from '@mui/material/RadioGroup';
import FormControlLabel from '@mui/material/FormControlLabel';
import Radio from '@mui/material/Radio';
import { withFormsy } from 'formsy-react';
import React from 'react';

function RadioGroupFormsy(props) {
  const importedProps = _.pick(props, [
    'children',
    'name',
    'onBlur',
    'onChange',
    'onKeyDown',
    'variant',
    'color',
  ]);

  // An error message is returned only if the component is invalid
  const { options, errorMessage, value, description } = props;

  function changeValue(event, val) {
    const selectedOption = options.find((o) => o.alias === val);
    props.setValue(selectedOption);
    if (props.onChange) {
      props.onChange(event);
    }
  }

  const formattedValue = (Array.isArray(value) ? value[0] : value)?.alias;

  const helperText = errorMessage || description;

  return (
    <FormControl
      error={Boolean((!props.isPristine && props.showRequired) || errorMessage)}
      className={props.className}
    >
      <FormControl
        disabled={props.disabled}
        component="fieldset"
        required={props.required}
        error={Boolean(errorMessage)}
      >
        {props.label && <FormLabel component="legend">{props.label}</FormLabel>}
        <RadioGroup {...importedProps} value={formattedValue || null} onChange={changeValue}>
          {options.map((option) => (
            <FormControlLabel
              value={option.alias}
              key={option.alias}
              control={<Radio />}
              label={option?.label || ''}
            />
          ))}
        </RadioGroup>
        {Boolean(helperText) && <FormHelperText>{helperText}</FormHelperText>}
      </FormControl>
    </FormControl>
  );
}

export default React.memo(withFormsy(RadioGroupFormsy));
